import { Directive, ElementRef, HostListener, Input } from '@angular/core';

const BACK_KEY = 8;
const SHIFT_KEY = 16;
@Directive({
    selector: '[appDateInput]'
})
export class DatenputDirective {

    @Input('appDateInput') appDateInput: string;

    constructor(private el: ElementRef) {

    }

    @HostListener('focus', ['$event']) onFocus(e: any) {
        this.el.nativeElement.setSelectionRange(0, this.el.nativeElement.value.length);
    }

    @HostListener('keydown', ['$event']) keydown(e: any) {
        const value: string = this.el.nativeElement.value;
        if (this.appDateInput !== 'month' && e.keyCode === BACK_KEY && value.length === 0) {
            this.el.nativeElement.previousElementSibling.focus();
        }
    }

    @HostListener('keyup', ['$event']) onKeyup(e: any) {
        const value: string = this.el.nativeElement.value;
        if (this.appDateInput !== 'year' && value.length === 2 && /^\d*$/.test(e.key)) {
            this.el.nativeElement.nextElementSibling.focus();
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/date-input.directive.ts